<template>
  <div class="upload">
    <div class="head">
      <img src="https://doc.medsky.cn/uploadArticle/videoUopload_pc.png" />
    </div>
    <div class="box">
      <div class="left">
        <img src="../../assets/image/组 1118@2x (1).png" />
        <videoAddEDit
          :_id="addEdit_id"
          @success_Click="successClick"
          @close_click="closeClick"
        />
      </div>
      <div class="right">
        <div class="right_head">
          <div class="right-head-img">
            <img src="@/assets/image/组 1119@2x.png" />
          </div>
        </div>
        <div class="right_box">
          <div class="recommed" v-if="recommendList && recommendList.length">
            <div
              class="recommed_item"
              v-for="(item, index) in recommendList"
              :key="index"
              @click="recommedClick(item)"
            >
              <div class="video_top_img">
                <div class="img_play">
                  <svg
                    t="1757401038539"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5915"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M512 42.666667C252.793333 42.666667 42.666667 252.793333 42.666667 512s210.126667 469.333333 469.333333 469.333333 469.333333-210.126667 469.333333-469.333333S771.206667 42.666667 512 42.666667z m196.546667 500.493333l-266.666667 176A37.333333 37.333333 0 0 1 384 688V336.033333a37.333333 37.333333 0 0 1 57.893333-31.16l266.666667 176a37.333333 37.333333 0 0 1 0 62.32z"
                      fill="#f6faff"
                      p-id="5916"
                    ></path>
                  </svg>
                </div>
                <img v-if="item.cover_img" :src="item.cover_img" />
                <img v-else src="../../assets/image/videoDefult.png" />
              </div>
              <div class="font">
                <div class="title ellipsis_single_2">{{ item.title }}</div>
                <!-- <div class="author">
                  <span>作者：</span>
                  <span>{{ item.author }}</span>
                </div> -->
              </div>
            </div>
          </div>
          <div class="zanwushuju" v-else>暂无数据</div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <!-- <span class="poptext">
        您的文件已经提交，我们会尽快审核！<br />文件审核通过，您会得到相应的积分奖励
      </span> -->
      <span class="poptext">
        {{ dialogVisibleConent.content }}
      </span>
      <div class="btn_footer">
        <span slot="footer" class="dialog-footer">
          <el-button
            style="
              background: linear-gradient(127deg, #2fd1c2 0%, #4986fe 100%);
              border-color: #2fd1c2;
            "
            class="changecolor"
            type="primary"
            @click="IKnows"
          >
            好的，我知道了
          </el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import videoAddEDit from "../../components/videoAddEDit.vue";
import videoApi from "../../api/popularScienceVideo";
export default {
  data() {
    return {
      addEdit_id: null,
      dialogVisible: false,
      dialogVisibleConent: {
        type: "",
        title: "",
        content: "",
      },
      recommendList: [],
    };
  },
  watch: {
    $route: {
      handler(val) {
        // console.log(val, "valvalval");
        if (val.query && val.query.id) {
          this.addEdit_id = val.query.id;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.recommendListAsync();
  },
  methods: {
    closeClick(row) {
      this.dialogVisibleConent = row;
      this.dialogVisible = true;
    },
    successClick() {
      console.log("成功");
      // this.dialogVisible
      if (this.$route.query && this.$route.query.id) {
        this.$router.back();
      } else {
        this.dialogVisible = true;
        this.closeClick({
          type: "video",
          title: "温馨提示",
          content:
            "您的文件已经提交成功，我们会尽快审核！ 如有问题，请联系项目组。",
        });
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    IKnows() {
      if (this.dialogVisibleConent.type == "certification") {
        this.$router.push("/user/certification");
      } else {
        this.$router.push("/user/videoManage");
      }
    },
    recommedClick(item) {
      this.$router.push(`/popularScienceVideoDetail?id=${item.id}`);
    },
    async recommendListAsync() {
      try {
        let res = await videoApi.recommendList({ page: 1, limit: 5 });
        if (res.code == 1) {
          this.recommendList = res.data.list;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  components: {
    videoAddEDit,
  },
};
</script>
<style scoped lang="less">
/deep/ .el-dialog__header {
  background: linear-gradient(180deg, #dbffef 0%, #ffffff 100%);
  color: #fff;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
}
.btn_footer {
  text-align: center;
  margin-top: 50px;
}
.upload {
  .head,
  img {
    width: 100%;
  }
  .box {
    display: flex;
    justify-content: center;
    // margin-bottom: 100px;
    margin: 44px 190px 100px 190px;
    .left {
      width: 1076px;
      margin-right: 40px;
      background-color: #ffffff;
      border: 1px solid #dce7ef;
      border-radius: 9px;
      // height: calc(100% + 42px);
      height: 1189;
      padding: 27px 34px 36px 67px;
    }
    .right {
      // flex: 1;
      .zanwushuju {
        margin-top: 50px;
        margin-left: 30px;
      }
      .right_head {
        margin-bottom: 15px;
        .right-head-img {
          width: 72px;
          height: 27px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .right_box {
        width:350px;
        padding: 25px 19px;
        background: #f4f8f8;
        border: 1px solid #dce7ef;
        border-radius: 10px;
        .recommed {
          .recommed_item:not(.recommed_item:last-child) {
            margin-bottom: 16px;
          }
          .recommed_item:hover {
            .img_play {
              display: flex !important;
              align-items: center;
              justify-content: center;
            }
            .font {
              .title {
                color: #6891ff;
              }
            }
          }
          .recommed_item {
            padding: 15px;
            background: #fff;
            border-radius: 10px;
            cursor: pointer;
            display: flex;
            .video_top_img {
              width: 120px;
              border-radius: 10px;
              overflow: hidden;
              margin-right: 13px;
              position: relative;
              .img_play {
                display: none;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.5);
                // display: flex;
                // align-items: center;
                // justify-content: center;
              }
              img {
                width: 100%;
                height: 100%;
              }
            }
            .font {
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .title {
                font-size: 16px;
                line-height: 26px;
                // height: 42px;
              }
              .author {
                span {
                  font-size: 15px;
                  color: #3b5c75;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
